import React, { useState, useEffect } from 'react';
import { Card } from 'antd-mobile';
import { Loading } from '../components';


import Statistic from '../components/Statistic';

import moment from 'moment';
import { GetSendStatistics } from "../../../api/usms";
import { getSthousandsFormatNum, getPercentFormat } from '../utils/common';

const TotalCountText = "对应-短信拆分条数：也即按照计费规则将短信字数拆分后的有效发送条数。举例，一条发往中国大陆的100字短信，短信提交条数是1，短信拆分条数是2；计费规则详见XXXXXXX";
const SuccessAndUnKnownCountCountText = "发送成功率(含未知) = (发送成功的短信提交条数+未知状态的短信提交条数) / 有效发送的短信提交条数";
const SuccessCountText = "发送成功率(不含未知) = 发送成功的短信提交条数 / 有效发送的短信提交条数";

// const AuthText = "发送成功率(含未知) = (发送成功的短信提交条数+未知状态的短信提交条数) / 有效发送的短信提交条数";
// const NotifyText = "发送成功率(含未知) = (发送成功的短信提交条数+未知状态的短信提交条数) / 有效发送的短信提交条数";
// const SaleText = "发送成功率(含未知) = (发送成功的短信提交条数+未知状态的短信提交条数) / 有效发送的短信提交条数";

/**
 * 发送相关数据
 * 获取国家维度数据，国外为所有非CN数据总和
 */
function SendOverview(props) {

    const { dateRange } = props;

    // 发送量
    const [statistics, setStatistics] = useState({});
    const [statisticsLoading, setStatisticsLoading] = useState(true);

    // 上一周期的数据，用于对比数据
    const [beforeStatistics, setBeforeStatistics] = useState({});
    const [beforeStatisticsLoading, setBeforeStatisticsLoading] = useState(true);

    useEffect(() => {
        changeDateRange(dateRange);
        // eslint-disable-next-line
    }, [dateRange])


    const getSendStatistics = (dates) => {
        setStatisticsLoading(true);
        setStatistics({});
        const data = {
            BeginTime: moment(dates[0]).unix(),
            EndTime: moment(dates[1]).unix(),
        }
        GetSendStatistics(data).then(res => {
            setStatistics(res)
            setStatisticsLoading(false);
        });
    }

    // 获取上一周期的数据
    const getBeforeSendStatistics = (dates) => {
        setBeforeStatisticsLoading(true);
        setBeforeStatistics({});
        const difference = dates[1].unix() - dates[0].unix(); // 时间差
        const data = {
            BeginTime: moment(dates[0]).unix() - difference - 1,
            EndTime: moment(dates[1]).unix() - difference - 1,
        }
        GetSendStatistics(data).then(res => {
            setBeforeStatistics(res)
            setBeforeStatisticsLoading(false);
        });
    }

    // 获取成功率百分比（含未知）
    const getSuccessAndUnKnownPercent = (statistic) => {
        if (statistic) {
            const successAndUnKnownPercent = getPercentFormat(statistic.SuccessCount + statistic.UnKnownCount, statistic.TotalCount);
            return successAndUnKnownPercent
        }
        return "0%"
    }

    // 获取成功率百分比（不含未知）
    const getSuccessPercent = (statistic) => {
        if (statistic) {
            const successPercent = getPercentFormat(statistic.SuccessCount, statistic.TotalCount);
            return successPercent
        }
        return "0%"
    }

    const changeDateRange = (rangeDates) => {
        getSendStatistics(rangeDates);
        getBeforeSendStatistics(rangeDates);
    }


    // const PurposeStatistic = ({ purpose }) => {
    //     const data = statistics[purpose] || {};
    //     const beforeData = beforeStatistics[purpose] || {};
    //     const titleOption = {
    //         Auth: "国内-验证码",
    //         Notify: "国内-通知",
    //         Sale: "国内-营销",
    //     }
    //     const textOption = {
    //         Auth: AuthText,
    //         Notify: NotifyText,
    //         Sale: SaleText
    //     }
    //     return <Loading loading={statisticsLoading || beforeStatisticsLoading}>
    //         <Card size='small' style={{ marginTop: "10px" }}>
    //             <Card.Header title={titleOption[purpose]} />
    //             <Card.Body>
    //                 {data ?
    //                     <Statistic
    //                         title="成功率(含未知)"
    //                         description={textOption[purpose]}
    //                         data={getSuccessAndUnKnownPercent(data)}
    //                         compareData={[
    //                             {
    //                                 name: "发送量",
    //                                 unit: "条",
    //                                 data: data.TotalCount,
    //                                 beforeData: beforeData.TotalCount,
    //                                 renderData: getSthousandsFormatNum
    //                             },
    //                             {
    //                                 name: "未知",
    //                                 data: data.UnKnownCount,
    //                                 unit: "条",
    //                                 beforeData: beforeData.UnKnownCount,
    //                                 renderData: getSthousandsFormatNum
    //                             },
    //                             {
    //                                 name: "成功",
    //                                 data: data.SuccessCount,
    //                                 unit: "条",
    //                                 beforeData: beforeData.SuccessCount,
    //                                 renderData: getSthousandsFormatNum
    //                             }
    //                         ]} /> : <Empty />}
    //             </Card.Body>
    //         </Card>
    //     </Loading>
    // }

    return <Loading loading={statisticsLoading || beforeStatisticsLoading}>
        <Card size="small" >
            <Card.Header title="整体概览" />
            <Card.Body>
                <Statistic
                    style={{ marginBottom: '10px' }}
                    title="发送总量"
                    description={TotalCountText}
                    data={statistics.Total && statistics.Total.TotalCostCount}
                    unit="条"
                    renderData={getSthousandsFormatNum}
                    compareData={[
                        // {
                        //     name: "国内",
                        //     data: statistics.Domestic && statistics.Domestic.TotalCostCount,
                        //     beforeData: beforeStatistics.Domestic && beforeStatistics.Domestic.TotalCostCount,
                        // },
                        {
                            name: "国外",
                            data: statistics.Foreign && statistics.Foreign.TotalCostCount,
                            beforeData: beforeStatistics.Foreign && beforeStatistics.Foreign.TotalCostCount,
                        }
                    ]} />
                <Statistic
                    style={{ marginBottom: '10px' }}
                    title="成功率(含未知)"
                    description={SuccessAndUnKnownCountCountText}
                    data={getSuccessAndUnKnownPercent(statistics.Total)}
                    compareData={[
                        // {
                        //     name: "国内",
                        //     data: getSuccessAndUnKnownPercent(statistics.Domestic),
                        //     beforeData: getSuccessAndUnKnownPercent(beforeStatistics.Domestic)
                        // },
                        {
                            name: "国外",
                            data: getSuccessAndUnKnownPercent(statistics.Foreign),
                            beforeData: getSuccessAndUnKnownPercent(beforeStatistics.Foreign)
                        }
                    ]} />
                <Statistic
                    title="成功率(不含未知)"
                    description={SuccessCountText}
                    data={getSuccessPercent(statistics.Total)}
                    compareData={[
                        // {
                        //     name: "国内",
                        //     data: getSuccessPercent(statistics.Domestic),
                        //     beforeData: getSuccessPercent(beforeStatistics.Domestic)
                        // },
                        {
                            name: "国外",
                            data: getSuccessPercent(statistics.Foreign),
                            beforeData: getSuccessPercent(beforeStatistics.Foreign)
                        }
                    ]} />
            </Card.Body>
        </Card>
        {/* <div>
            <PurposeStatistic purpose="Notify" />
            <PurposeStatistic purpose="Auth" />
            <PurposeStatistic purpose="Sale" />
        </div> */}
    </Loading>
}
export default SendOverview